import { useContext } from "react";
import { NewsPageContext } from "../contexts/newsPageContext";

const useNewsPageContext = () => useContext(NewsPageContext);

export { useNewsPageContext };
